module.exports = __webpack_public_path__ + "static/media/podcast.3ae657b1.svg";